export const GET_SUB_CATEGORIES = 'GET_SUB_CATEGORIES';
export const SET_SUB_CATEGORIES = 'SET_SUB_CATEGORIES';
export const API_ERROR = 'LOGIN_API_ERROR';
export const SET_SUB_CATEGORY = 'SET_SUB_CATEGORY';
export const ADD_SUB_CATEGORY = 'ADD_SUB_CATEGORY';
export const EMPTY_SUB_CATEGORY = 'EMPTY_SUB_CATEGORY';
export const DELETE_SUB_CATEGORY = 'DELETE_SUB_CATEGORY';
export const EDIT_SUB_CATEGORY = 'EDIT_SUB_CATEGORY';
export const UPDATE_SUB_CATEGORY = 'UPDATE_SUB_CATEGORY';
export const SET_SUB_CATEGORY_FILTER = 'SET_SUB_CATEGORY_FILTER';